import React from "react";
import logo from "../../images/w logo beli.png";
import "./Header.css";
import Navbar from "../Navbar/Navbar";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import usaid_logo from "../../images/usaid_logo.svg";
import srbijainovira_logo from "../../images/srbijainovira_logo.svg";
import icthub_logo from "../../images/icthub_logo.svg";
import odlicantri_logo from "../../images/odlicantri_logo.svg";
import moonstruck_logo from "../../images/moonstruck_logo.svg";

import { Link } from "react-router-dom";

export default function Header() {
  const { token, userId } = useContext(AppContext);
  const location = useLocation();
  const isWelcomePage = location.pathname === "/";
  const isRegister = location.pathname === "/register";
  const isLogin = location.pathname === "/login";

  const linkPath = userId ? `/home/user/${userId}` : "/";

  return (
    <div className="header-container">
      <div className="logo-container">
        <Link to={linkPath}>
          <img className="logo" alt="moonstruck logo" src={logo} />
        </Link>
        {isWelcomePage && (
          <div className="welcome-page-logos">
            <img src={usaid_logo} alt="usaid_icthub" />
            <img src={srbijainovira_logo} alt="srbijainovira_logo" />
            <img src={icthub_logo} alt="icthub_logo" />
            <img src={odlicantri_logo} alt="odlicantri_logo" />
            <img src={moonstruck_logo} alt="moonstruck_logo" />
          </div>
        )}
      </div>
      {token && !isWelcomePage && !isRegister && !isLogin && <Navbar />}
    </div>
  );
}
